export default __webpack_public_path__ + "static/media/gallery_04.85685581.jpg";